export const clientsPageTranslationsPl = {
    clientsPage: 'Klienci',
    clientEmail: 'Adres e-mail',
    clientNip: 'NIP',
    clientName: 'Nazwa klienta',
    clientPhoneNumber: 'Numer telefonu',
    clientStreet: 'Ulica',
    clientHouseNumber: 'Nr domu',
    clientApartmentNumber: 'Nr lokalu',
    clientCity: 'Miasto',
    clientZipCode: 'Kod pocztowy',
    clientCountry: 'Państwo',
    clientNotes: 'Uwagi',
    clientAddClient: 'Dodaj nowego klienta',
    clientRemoveConfirmationMessage: 'Czy na pewno chcesz usunąć wybranego klienta?',
    clientDelete: 'Usuń klienta',
    clientUpdate: 'Edytuj klienta',
    clientsConflictedEmail: 'Podany adres e-mail już istnieje',
};
export const clientsPageTranslationsEn = {
    clientsPage: 'Clients',
    clientEmail: 'E-mail',
    clientNip: 'NIP',
    clientName: 'Client name',
    clientPhoneNumber: 'Phone number',
    clientStreet: 'Street',
    clientHouseNumber: 'House number',
    clientApartmentNumber: 'Apartment number',
    clientCity: 'City',
    clientZipCode: 'Zip code',
    clientCountry: 'Country',
    clientNotes: 'Remarks',
    clientAddClient: 'Add new client',
    clientRemoveConfirmationMessage: 'Are you sure you want to delete the selected client?',
    clientDelete: 'Remove client',
    clientUpdate: 'Update client',
    clientsConflictedEmail: 'Given e-mail address is already defined',
};
